export default "__VITE_ASSET__Q8Svq2$e__"